import React from 'react';
import { getMobileAppHeading, getMobileAppPoints } from './GetAppMobile';
import { webConfig } from '../../utils/webConfig';
import { IconButton } from '@mui/material';
import { Icon } from '../Donee/components/common';
import QRCodeSection from './QRCodeSection';

interface GetAppDesktopProps {
    className?: string;
    onClose?: () => unknown;
}

const GetAppDesktop: React.FC<GetAppDesktopProps> = ({
    className,
    onClose,
}) => {
    return (
        <div className={`hidden md:flex ${className ?? ''}`}>
            <div className="flex-1 w-[368px] p-9 rounded-l-[32px] bg-[#fff1e8]">
                <div className="mb-3">{getMobileAppHeading}</div>
                {getMobileAppPoints}
                <img
                    className="mt-8"
                    src={webConfig.getAppMobileUrl}
                    alt="App mobile QR"
                />
            </div>
            <div className="flex-1 w-[368px] flex flex-col relative px-6 text-center">
                {onClose && (
                    <div className="flex p-6 absolute top-0 right-0 justify-end">
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                        >
                            <Icon name={'close-icon'} />
                        </IconButton>
                    </div>
                )}
                <QRCodeSection />
            </div>
        </div>
    );
};

export default GetAppDesktop;
